import React, { useState, useEffect, useCallback } from 'react';

import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from 'react-i18next';

import useWindowSize from '../global/parts/windowsSize';
import { ButtonStyle } from '../global/parts/buttons';
import clientcover from '../../images/clientscover.png';

gsap.registerPlugin(ScrollTrigger)

const ClientsSectionStyled = styled.div`
    overflow: hidden;
    @media (min-width: 1023px) {
        .containermain{
            display: flex;
            flex-direction: column;
        }
    }
    .clientsectioncanvas {
        width: 100%;
        height: 100vh;
        background-color: var(--backgrounda);
        position: relative;
    }
    .clientpicture{
        top: 50vh;
        transform:translate(0, -50%);
        position:relative;
        background-color: var(--themecolorc);
        background-position:top top;
        background-image: url(${clientcover});
        background-size: 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        opacity: 1;
        z-index: 1;
        object-fit: cover;
        width: 100vw;
        height: 70vh;
        box-shadow: 0 30px 40px var(--bordertext);
        @media (min-width: 1023px) {
            background-position:center center;
            position: absolute;
            width: 38vw;
            height: 70vh;
            right: var(--margin);
            border-radius: 30px;
        }
    }
    .clientcontentcontainer{
        position: relative;
        top: 0;
        left: 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex-wrap: center;
        opacity: 0;
        z-index: 5;
        padding: var(--marginhalf) var(--marginhalf) var(--marginhalf) var(--marginhalf);
        @media (min-width: 1023px) {
            top: 10vh;
            position: absolute;
            background-color: transparent;
            padding: var(--margin) 15vh var(--margin) var(--margin);
            width: 50vw;
            height: 100vh;
        }
    }
    .clientword{
        text-align: center;
        font-size: var(--fontsizetitlec);
        font-weight: bold;
        position: relative;
        color: var(--texta);
        background-color: transparent;
        padding-bottom: 3vh;
        @media (min-width: 1023px) {
            text-align: left;
            font-size: var(--fontsizetitlea);
        }
    }
    .clientcontent{
        text-align: center;
        font-size: var(--fontsizecontentc);
        font-weight: 10;
        position: relative;
        color: var(--backgroundb);
        background-color: transparent;
        top: 7vh;
        @media (min-width: 1023px) {
            text-align: left;
        }
    }
    .button{
        position: relative;
    }
`;

function ClientsSection() {
    const size = useWindowSize();
    const [t, i18n] = useTranslation();

    gsap.to('.clientcontentcontainer', {
        scrollTrigger: {
            markers: false,
            trigger: ".clientword",
            toogleActions: "restart pause reverse pause",
            start: "top 50%",
            end: "+=5%",
            scrub: 1,
        },
        opacity: 1,
    })

    return (
        <ClientsSectionStyled>
            <div className="clientsectioncanvas" >
                <div className="containermain">
                    <div className="clientcontentcontainer">
                        <div className="clientcontent">
                            <div className="clientword">
                                {t('ClientsSection.title')}
                            </div>
                            <i>{t('ClientsSection.descriptiona')}</i>
                            <br />
                            {t('ClientsSection.descriptionb')}
                            <br />
                            <br />
                            <br />
                            <br />
                            <a href="/clients/">
                                <div className="button">
                                    <ButtonStyle>
                                        {t('ClientsSection.learnmore')}
                                    </ButtonStyle>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="clientpicture" />
            </div>
        </ClientsSectionStyled>
    )
}

export default ClientsSection;